import { render, staticRenderFns } from "./AddOption.vue?vue&type=template&id=07c03e9a&scoped=true&"
import script from "./AddOption.vue?vue&type=script&lang=js&"
export * from "./AddOption.vue?vue&type=script&lang=js&"
import style0 from "./AddOption.vue?vue&type=style&index=0&id=07c03e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c03e9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSwitch,VTextField})
